import { type VariantProps, cva } from "class-variance-authority";

export const tableRow = cva(
  [
    "h-11 max-h-12",
    "bg-elevation-fill-default-1",
    "hover:bg-elevation-fill-default-2",
    "disabled:opacity-50",
    "selected:bg-elevation-fill-default-0",
    "hover:selected:bg-elevation-fill-default-0",
    "clickable:cursor-pointer",
    "focus-within:bg-elevation-fill-default-2",
  ],
  {
    variants: {
      alternatingBackground: {
        even: "even:bg-elevation-fill-inverted-4/5",
        odd: "odd:bg-elevation-fill-inverted-4/5",
      },
    },
  },
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - When overriding cva types, it causes a type error
export interface TableRowVariantProps extends VariantProps<typeof tableRow> {}

export const tableHeadRow = cva(["z-10 h-11 w-full bg-elevation-fill-default-2"]);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - When overriding cva types, it causes a type error
export interface TableHeadRowVariantProps extends VariantProps<typeof tableHeadRow> {}

export const tableHeadData = cva(
  [
    "border-b border-b-elevation-outline-default-1 border-solid px-4 py-2.5 text-left", // px-4 and py-2.5 are calculation of the cell padding and the content padding, but since we don't have support to declare content padding, we are combining them here
  ],
  {
    variants: {
      hasRightBorder: {
        true: "border-l border-l-elevation-outline-default-1 border-solid",
        false: "",
      },
    },
    defaultVariants: {
      hasRightBorder: true,
    },
  },
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - When overriding cva types, it causes a type error
export interface TableHeadDataVariantProps extends VariantProps<typeof tableHeadData> {}

export const tableData = cva(
  [
    "relative h-0-5 overflow-hidden text-ellipsis whitespace-nowrap border-t border-t-transparent px-4 py-2.5",
    "border-b border-b-elevation-outline-default-1",
    "has-[*>[data-hovered]:not([data-disabled])]:hover:border-b-input-outlined-outline-hover",
    "has-[*>[data-invalid]]:border-b-input-outlined-outline-error!",
    "has-[*>[data-focused]]:border-b-input-outlined-outline-active",
  ],
  {
    variants: {
      hasRightBorder: {
        true: "border-l border-l-elevation-outline-default-1",
        false: "",
      },
    },
    defaultVariants: {
      hasRightBorder: true,
    },
  },
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - When overriding cva types, it causes a type error
export interface TableDataVariantProps extends VariantProps<typeof tableData> {}
